<h2 mat-dialog-title>{{concert.title}}</h2>
<mat-dialog-content class="mat-typography">
  <markdown ngPreserveWhitespaces>
  {{concert.description}}
  </markdown>
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-button mat-dialog-close>FERMER</button>
</mat-dialog-actions>
